module.exports = __webpack_public_path__ + "e756ef7eea6d85f14e28a454392b8b61.jpg";